/** Side-by-side rows aligned with the school drawer / ranking fields. */

export const COMPARE_SLOTS = 4;

export const COMPARE_GROUPS = [
  {
    id: "overview",
    label: "Overview",
    hideLabel: true,
    rows: [
      { key: "gender", label: "Gender", kind: "text" },
      { key: "area", label: "Local authority", kind: "text" },
      { key: "catchment", label: "Catchment", kind: "text" },
      { key: "miles", label: "Miles from home", kind: "num", digits: 1, better: "low" },
      { key: "examSubjects", label: "11+ exam subjects", kind: "text" },
      { key: "ofsted", label: "Ofsted", kind: "text" },
      { key: "oxbridge", label: "Oxbridge offers", kind: "num", digits: 0, better: "high" },
    ],
  },
  {
    id: "gcse",
    label: "GCSE",
    rows: [
      { key: "gcseRank", label: "GCSE rank", kind: "num", digits: 0, better: "low" },
      { key: "attainment8", label: "Attainment 8", kind: "num", digits: 1, better: "high" },
      { key: "grade9", label: "Grade 9", kind: "pct", digits: 1, better: "high" },
      { key: "grade89", label: "Grades 8–9", kind: "pct", digits: 1, better: "high" },
      { key: "grades79", label: "Grades 7–9", kind: "pct", digits: 1, better: "high" },
      { key: "engMaths5", label: "Eng & maths 5+", kind: "pct", digits: 1, better: "high" },
      { key: "ebaccAps", label: "EBacc APS", kind: "num", digits: 1, better: "high" },
      { key: "gcseYear", label: "GCSE year", kind: "text" },
    ],
  },
  {
    id: "alevel",
    label: "A level",
    rows: [
      { key: "alevelRank", label: "A level rank", kind: "num", digits: 0, better: "low" },
      { key: "alevelPoints", label: "Points per entry", kind: "num", digits: 1, better: "high" },
      { key: "alevelGrade", label: "Average grade", kind: "text" },
      { key: "alevelAstar", label: "A*", kind: "pct", digits: 1, better: "high" },
      { key: "alevelAstarA", label: "A*–A", kind: "pct", digits: 1, better: "high" },
      { key: "alevelAstarB", label: "A*–B", kind: "pct", digits: 1, better: "high" },
      { key: "aab", label: "AAB+", kind: "pct", digits: 1, better: "high" },
      { key: "valueAdded", label: "Value added", kind: "num", digits: 2, better: "high" },
      { key: "valueAddedBand", label: "Progress band", kind: "text" },
      { key: "ks5Year", label: "A level year", kind: "text" },
    ],
  },
  {
    id: "after",
    label: "Destinations",
    rows: [
      { key: "university", label: "Higher education", kind: "pct", digits: 1, better: "high" },
    ],
  },
];

export function formatCompareValue(value, row) {
  if (value == null || value === "") return "—";
  if (row.kind === "text") return String(value);
  const n = Number(value);
  if (!Number.isFinite(n)) return "—";
  const digits = row.digits ?? 0;
  const text = digits > 0 ? n.toFixed(digits) : String(Math.round(n));
  return row.kind === "pct" ? `${text}%` : text;
}

/** Index of the best numeric cell among filled slots, or -1. */
export function bestSlotIndex(values, better) {
  if (!better || values.length < 2) return -1;
  let best = -1;
  let bestVal = null;
  values.forEach((raw, index) => {
    const n = Number(raw);
    if (!Number.isFinite(n)) return;
    if (bestVal == null) {
      best = index;
      bestVal = n;
      return;
    }
    if (better === "high" && n > bestVal) {
      best = index;
      bestVal = n;
    }
    if (better === "low" && n < bestVal) {
      best = index;
      bestVal = n;
    }
  });
  if (best < 0) return -1;
  const winners = values.filter((raw) => Number(raw) === bestVal).length;
  return winners > 1 ? -1 : best;
}
